import discard from "../../assets/shapes_svg/roledetail/discard.svg";
const DiscardChangeIcon = ({ click, style }) => {
  return (
    <>
      <div
        className={"companydetail__delete " + "delete__style" + style}
        onClick={click}
        style={{ marginLeft: "5px" }}
      >
        <img
          className=""
          src={discard}
          alt=""
          style={{ width: "35%", maxWidth: "20px" }}
        />
      </div>
    </>
  );
};

export default DiscardChangeIcon;
